import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_MAIN = "https://customer-assets.emergentagent.com/job_ce22ad00-db82-461a-af39-4177f369e9d1/artifacts/wsj2zzd9_ETHIDA%202%20BLACK%20Mittel.png";

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-[#020408] text-white">
      <div className="container mx-auto px-5 py-12 max-w-3xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <Link to="/" className="flex items-center gap-2 text-[#a3e635] hover:text-[#22d3ee] transition-colors" data-testid="back-to-home-ds">
            <ArrowLeft size={20} />
            <span className="text-sm font-medium">Zurück zur Startseite</span>
          </Link>
          <img src={LOGO_MAIN} alt="ENTHIDA Logo" className="h-8 opacity-60" />
        </div>

        <h1 className="text-3xl md:text-4xl font-bold mb-8" data-testid="datenschutz-title">Datenschutzerklärung</h1>

        <div className="space-y-8 text-slate-300 leading-relaxed">
          {/* Verantwortlicher */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. Verantwortlicher</h2>
            <p>
              ENTHIDA – Smart Energy Systems<br />
              Inh. Enes Dedic<br />
              Ludwig-Stempfl-Str. 17<br />
              84307 Eggenfelden<br />
              E-Mail: info@enthida.de<br />
              Telefon: +49 176 41234 614
            </p>
          </section>

          {/* Übersicht */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. Übersicht der Verarbeitungen</h2>
            <p>
              Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und die Zwecke ihrer Verarbeitung
              zusammen und verweist auf die betroffenen Personen.
            </p>
            <p className="mt-2">
              <strong className="text-white">Arten der verarbeiteten Daten:</strong><br />
              Bestandsdaten, Kontaktdaten, Inhaltsdaten, Nutzungsdaten, Meta-/Kommunikationsdaten.
            </p>
            <p className="mt-2">
              <strong className="text-white">Kategorien betroffener Personen:</strong><br />
              Nutzer der Website, Kommunikationspartner, Geschäftskunden.
            </p>
          </section>

          {/* Rechtsgrundlagen */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. Maßgebliche Rechtsgrundlagen</h2>
            <p>
              Im Folgenden erhalten Sie eine Übersicht der Rechtsgrundlagen der DSGVO, auf deren Basis wir
              personenbezogene Daten verarbeiten:
            </p>
            <ul className="mt-2 space-y-1 list-disc list-inside">
              <li><strong className="text-white">Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO)</strong> – Die betroffene Person hat ihre Einwilligung erteilt.</li>
              <li><strong className="text-white">Vertragserfüllung (Art. 6 Abs. 1 S. 1 lit. b DSGVO)</strong> – Verarbeitung zur Erfüllung eines Vertrags.</li>
              <li><strong className="text-white">Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f DSGVO)</strong> – Verarbeitung zur Wahrung berechtigter Interessen.</li>
            </ul>
          </section>

          {/* Hosting */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. Bereitstellung des Onlineangebotes und Webhosting</h2>
            <p>
              Wir verarbeiten die Daten der Nutzer, um ihnen unsere Online-Dienste zur Verfügung stellen zu können.
              Zu diesem Zweck verarbeiten wir die IP-Adresse des Nutzers, die notwendig ist, um die Inhalte und
              Funktionen unserer Online-Dienste an den Browser bzw. das Endgerät der Nutzer zu übermitteln.
            </p>
            <p className="mt-2">
              <strong className="text-white">Erhobene Daten:</strong> IP-Adresse, Datum und Uhrzeit der Anfrage,
              Inhalt der Anfrage, Zugriffsstatus/HTTP-Statuscode, jeweils übertragene Datenmenge, Website, von der die
              Anforderung kommt, Browser, Betriebssystem und dessen Oberfläche, Sprache und Version der Browsersoftware.
            </p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. Einsatz von Cookies</h2>
            <p>
              Cookies sind kleine Textdateien bzw. sonstige Speichervermerke, die Informationen auf Endgeräten
              speichern und aus ihnen auslesen. Wir setzen Cookies ein, um die Funktionalität unserer Website zu
              gewährleisten und um die Nutzung unserer Website statistisch zu erfassen.
            </p>
            <p className="mt-2">
              <strong className="text-white">Arten von Cookies:</strong>
            </p>
            <ul className="mt-1 space-y-1 list-disc list-inside">
              <li><strong className="text-white">Notwendige Cookies:</strong> Für den Betrieb der Website erforderlich.</li>
              <li><strong className="text-white">Analyse-Cookies:</strong> Zur statistischen Auswertung der Websitenutzung (z.B. Google Analytics).</li>
            </ul>
            <p className="mt-2">
              Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und
              Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell
              ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
            </p>
          </section>

          {/* Google Analytics */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. Google Analytics</h2>
            <p>
              Wir nutzen Google Analytics, einen Webanalysedienst der Google Ireland Limited, Gordon House,
              Barrow Street, Dublin 4, Irland ("Google"). Google Analytics verwendet Cookies, die eine Analyse
              der Benutzung der Website durch Sie ermöglichen.
            </p>
            <p className="mt-2">
              Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel
              an einen Server von Google in den USA übertragen und dort gespeichert. Wir haben die IP-Anonymisierung
              auf dieser Website aktiviert, sodass Ihre IP-Adresse von Google innerhalb der EU gekürzt wird.
            </p>
            <p className="mt-2">
              <strong className="text-white">Rechtsgrundlage:</strong> Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO).
              Sie können Ihre Einwilligung jederzeit widerrufen.
            </p>
            <p className="mt-2">
              <strong className="text-white">Opt-Out:</strong> Sie können die Erfassung durch Google Analytics verhindern,
              indem Sie das Browser-Add-on zur Deaktivierung von Google Analytics installieren:{" "}
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-[#22d3ee] hover:underline">
                https://tools.google.com/dlpage/gaoptout
              </a>
            </p>
          </section>

          {/* Kontaktaufnahme */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. Kontaktaufnahme</h2>
            <p>
              Bei der Kontaktaufnahme mit uns (z.B. per Telefon, E-Mail oder WhatsApp) werden die Angaben des
              Nutzers zur Bearbeitung der Kontaktanfrage und deren Abwicklung verarbeitet.
            </p>
            <p className="mt-2">
              <strong className="text-white">Rechtsgrundlage:</strong> Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f DSGVO),
              Vertragserfüllung (Art. 6 Abs. 1 S. 1 lit. b DSGVO).
            </p>
          </section>

          {/* Betroffenenrechte */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">8. Rechte der betroffenen Personen</h2>
            <p>Ihnen stehen als Betroffene nach der DSGVO verschiedene Rechte zu:</p>
            <ul className="mt-2 space-y-1 list-disc list-inside">
              <li><strong className="text-white">Auskunftsrecht (Art. 15 DSGVO)</strong></li>
              <li><strong className="text-white">Recht auf Berichtigung (Art. 16 DSGVO)</strong></li>
              <li><strong className="text-white">Recht auf Löschung (Art. 17 DSGVO)</strong></li>
              <li><strong className="text-white">Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</strong></li>
              <li><strong className="text-white">Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</strong></li>
              <li><strong className="text-white">Widerspruchsrecht (Art. 21 DSGVO)</strong></li>
              <li><strong className="text-white">Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO)</strong></li>
              <li><strong className="text-white">Beschwerderecht bei einer Aufsichtsbehörde (Art. 77 DSGVO)</strong></li>
            </ul>
          </section>

          {/* SSL */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">9. SSL-Verschlüsselung</h2>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine
              SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des
              Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
          </section>

          {/* Aktualität */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">10. Aktualität und Änderung dieser Datenschutzerklärung</h2>
            <p>
              Diese Datenschutzerklärung ist aktuell gültig und hat den Stand April 2026. Durch die
              Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben
              kann es notwendig werden, diese Datenschutzerklärung zu ändern.
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-6 border-t border-white/10 text-center">
          <Link to="/" className="text-[#a3e635] hover:text-[#22d3ee] transition-colors text-sm font-medium">
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}
